import { Skills } from "../config"

const Skill = () => {
    return (
        <section id="skills" className="py-24 md:py-32">
            <div className="flex items-center gap-24 p-3 px-5 md:px-32 py-2 overflow-x-auto no-scrollbar">
                <div className="w-1/2 absolute">
                    <h1 className="text-4xl font-medium mb-3">My <span className="text-primary">skills</span></h1>
                    <p className="text-lg font-light text-gray-300">Let's make great things with the skills I have</p>
                </div>
                <div className="flex gap-5 pl-52 md:pl-96 md:ml-44">
                    {Skills.map(service => (
                        <div key={service.id} className="group h-64 w-56 shadow-md rounded bg-white px-5 pb-5 flex flex-col items-start justify-end overflow-hidden relative">
                            <div className="w-32 h-32 bg-primary rounded-full absolute -top-10 -right-10" />
                            <div className="w-20 h-20 bg-gray-100 rounded-full absolute -top-10 -left-10" />
                            <div className="rounded-full p-3 mb-4 bg-primary">
                                {service.icon}
                            </div>
                            <h4 className="text-xl font-medium">{service.title}</h4>

                            <div className="flex gap-3 justify-center items-center h-full w-full absolute top-0 left-0 bg-black opacity-0 group-hover:opacity-80 animation duration-500">
                                {service.techs.map((tech, i) => (
                                    <div key={i} className="rounded-full p-3 mb-4 bg-primary" title={tech.title}>
                                        {tech.icon}
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Skill